import { Component, OnInit } from '@angular/core';
import {Observable} from 'rxjs';
import {shareReplay} from 'rxjs/operators';
import {AuthService} from '../../services/auth.service';
import {HttpService} from '../../services/http.service';
import {environment} from '../../../environments/environment';
import { ToastService } from 'src/app/services/toast.service';
import { ThemeService, ThemeName, ThemeOption } from 'src/app/services/theme.service';

@Component({
  selector: 'app-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss']
})
export class UserSettingsComponent implements OnInit {
  public user$: Observable<any>;
  private _id: string = '';
  public name: string = '';
  public email: string = '';
  public avatar: string = '';
  public password: string = '';

  public allowSave: boolean = false;

  public themes: ThemeOption[] = ThemeService.THEMES;
  public selectedTheme: ThemeName = 'theme-light';

  public fontOptions = ThemeService.FONT_OPTIONS;
  public selectedFont: string = 'Roboto';

  constructor(
    private authService: AuthService,
    private httpService: HttpService,
    private toastService: ToastService,
    private themeService: ThemeService
  ) {
    this.user$ = this.authService.getCurrentUser().pipe(
      shareReplay()
    );
    this.user$.subscribe(res => {
      this._id = res._id;
      this.name = res.name;
      this.email = res.email;
      this.avatar = res.avatar;
    })
  }

  ngOnInit(): void {
    this.selectedTheme = this.themeService.getTheme();
    this.selectedFont = this.themeService.getFont();
  }

  public onThemeChange(theme: ThemeName): void {
    this.selectedTheme = theme;
    this.themeService.setTheme(theme);
    this.themeService.resetFont();
    this.selectedFont = this.themeService.getFont();
  }

  public onFontChange(font: string): void {
    this.selectedFont = font;
    this.themeService.setFont(font);
  }

  public onChange(): void {
    this.allowSave = true;
  }

  public save(): void {
    this.allowSave = false;
    this.httpService.post(environment.API_PATH + '/user/update', {
      _id: this._id,
      name: this.name,
      email: this.email,
      avatar: this.avatar,
      password: this.password
    }).subscribe(res => {
      this.authService.fetchCurrentUser().subscribe(res => {});
      console.log(res);
      this.toastService.success(res.message);
    });
  }
}
